import { Image } from "primereact/image";
import { useEffect, useState } from "react";
import { Tooltip } from "primereact/tooltip";
import { Tree } from "primereact/tree";

import {
  labelArchive,
  labelArchivio,
  labelCodes,
  labelCodex,
  labelFonteUsed,
  labelFonti,
  labelFontiUsed,
  labelNoSource,
  labelPrivate,
  labelPrivates,
  labelSourceDeleteTree,
  labelSourceUpdate,
  labelToneOfVoce,
  labelTooltipPdf,
} from "_constants";
import { getFileIconByFileType, getTypeToneOfVoice } from "utils";
import toneVoiceIcon from "assets/icons/icon_tone_of_voice.svg";
import { Answer, SourceChat } from "interfaces";

export const ModalResolveReportPartiallyWrongBodyLeftToneOfVoice = ({
  answer,
}: {
  answer: Answer;
}) => {
  const [sourceCount, setSourceCount] = useState(0);
  const selectedKey = "";
  const [nodes, setNodes] = useState<any[]>([]);
  useEffect(() => {
    if (answer) {
      setSourceCount(
        answer!.sourcesList?.length +
          answer!.privateSourcesList?.length +
          answer!.codesList?.length
      );
      const data = [
        ...(answer?.codesList?.length
          ? [
              {
                key: "0",
                label: labelCodes,
                children: answer?.codesList.map((code: SourceChat) => ({
                  label: code.name,
                  type: labelCodex,
                  stateUpdate: code.stateUpdate,
                })),
              },
            ]
          : []),
        ...(answer?.sourcesList?.length
          ? [
              {
                key: "1",
                label: labelArchivio,
                children: answer?.sourcesList.map((source: SourceChat) => ({
                  label: source.name,
                  fileType: source.fileType,
                  type: labelArchive,
                  stateUpdate: source.stateUpdate,
                })),
              },
            ]
          : []),
        ...(answer?.privateSourcesList?.length
          ? [
              {
                key: "2",
                label: labelPrivate,
                children: answer?.privateSourcesList.map(
                  (privateSource: SourceChat) => ({
                    label: privateSource.name,
                    fileType: privateSource.fileType,
                    type: labelPrivates,
                    stateUpdate: privateSource.stateUpdate,
                  })
                ),
              },
            ]
          : []),
      ];
      setNodes(data);
    }
  }, [answer]);
  const nodeTemplate = (node: any) => {
    const isParentNode = !!node.children;
    const isFileType = node.fileType;
    const roundSourceLabel = () => {
      if (node.label === "Codici") {
        return <span className="round-source margin-right-5"></span>;
      } else if (node.label === "Archivio") {
        return <span className="round-source margin-right-5 archive"></span>;
      } else if (node.label === "Privata") {
        return <span className="round-source margin-right-5 private"></span>;
      }
      return null;
    };
    return (
      <div className="flex-container align-center relative width-80 tree-source overflow-hidden">
        {isParentNode && roundSourceLabel()}
        {!isParentNode && isFileType && (
          <Image
            src={getFileIconByFileType(node.fileType)}
            alt={labelTooltipPdf}
          />
        )}
        <Tooltip
          target={`.resolve-report-label`}
          position="bottom"
          mouseTrack
          mouseTrackLeft={10}
        />
        <div className="flex-container column gap-2 overflow-hidden ">
          <span
            className={`margin-left-7 ellipsis resolve-report-label ${
              isParentNode ? "font-weight-700" : ""
            }
            ${node.stateUpdate === "ELIMINATO" ? "line-through" : ""}`}
            data-pr-tooltip={!isParentNode ? node.label : ""}
          >
            {node.label}
          </span>
          <span className="margin-left-7 text-sm-blue">
            {node.stateUpdate === "ELIMINATO"
              ? labelSourceDeleteTree
              : node.stateUpdate === "DEPRECATO"
              ? labelSourceUpdate
              : ""}
          </span>
        </div>
      </div>
    );
  };
  return (
    <div className="container-source-response width-px-300">
      <div className="header">
        <span className="text-title font-weight-700">{labelToneOfVoce}</span>
        <div className="flex-container gap-4 margin-top-8">
          <Image src={toneVoiceIcon} alt="" />
          <span className="text-base-regular  font-weight-500 italic ">
            {getTypeToneOfVoice(answer?.toneOfVoice ?? 0)}
          </span>
        </div>
      </div>
      <div className="padd-18 flex-container column gap-8">
        <span className="text-title font-weight-700">
          {labelFonti.toUpperCase()}
        </span>
        <span
          className={`text-base-regular font-weight-500 ${
            sourceCount === 0 ? "italic" : ""
          }`}
        >
          {" "}
          {`${
            sourceCount === 0
              ? labelNoSource
              : sourceCount === 1
              ? `${sourceCount} ${labelFonteUsed}`
              : `${sourceCount} ${labelFontiUsed}`
          }`}
        </span>
      </div>
      {nodes.length > 0 && (
        <div className="source-tree no-bar">
          <Tree
            value={nodes}
            selectionMode="single"
            selectionKeys={selectedKey}
            className="width-100 tree-detail"
            nodeTemplate={nodeTemplate}
          />
        </div>
      )}
    </div>
  );
};
